


































































































































/* eslint-disable max-len */
import {
  defineComponent, reactive, toRefs, onBeforeMount, PropType, computed, ComputedRef, ref, watch,
} from '@vue/composition-api'
import Pod from '@/components/layouts/Pod.vue'
import PodCard from '@/components/layouts/PodCard.vue'
import ApiError from '@/components/appBase/errors/ApiError.vue'
import DelayedDisplay from '@/components/appBase/DelayedDisplay.vue'
import useApiErrorViewHandler from '@/components/appBase/errors/useApiErrorViewHandler'
import useClientflowApi from '@/api/clientFlow/useClientflowApi'
import Editor from '@/components/appBase/Editor.vue'

// const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

/**
 * TODO: this is just copy paste .. dont need remote here, fix it later
 * Shape of the data, that we get from vuex store.
 * TODO: put this definition somewhere in the store.
 */
interface RemoteSessionData {
  date: string;
  clientId: string;
  therapistId: string;
  note?: string;
  localReference?: string;
}

type existingSessionData = RemoteSessionData & {
  id: string;
}

type newSessionData = RemoteSessionData & {
  date?: string;
}

type SessionData = existingSessionData | newSessionData

const isNewSession = (s: SessionData): s is newSessionData => (s as existingSessionData).id === undefined
const isExistingSession = (s: SessionData): s is existingSessionData => (s as existingSessionData).id !== undefined

type State = {
  loading: boolean;
  editToggle: boolean;
  valid: boolean;
  sessionData?: SessionData;
  datePickerDate: string | undefined;

}

const initialState: State = {
  loading: true,
  valid: true,
  editToggle: false,
  sessionData: undefined,
  datePickerDate: undefined,
}

export default defineComponent({
  components: {
    ApiError, DelayedDisplay, Pod, PodCard, Editor,
  },
  props: {
    session: {
      type: Object as PropType<SessionData>,
      required: true,
    },

    clientId: { type: String, default: '' },
  },

  setup(props, context) {
    // Set up state
    const state = reactive({ ...initialState })

    // refs in the template (remember to also `return` them)
    // these are components that provide functionality (functions)
    const editorRef = ref(null)
    // const createClientFormRef = ref(null)

    // Compose!
    // ...delegate api handling to useClientflowApi():
    const {
      ClientFlowApi,
      awaitingResponse,
      hasResponseError,
      handler,
      // reset,
      errorDisplay,
    } = useClientflowApi()

    // ...delegate logic around showing api error to useApiErrorViewHandler():
    const {
      errorVisibilityHasChangedTo,
      toggleShowApiError,
      showResponseError,
      showingResponseError,
    } = useApiErrorViewHandler(hasResponseError)

    const getFormattedDate = (dateStr: string) => new Date(dateStr).toLocaleDateString(
      context.root.$vuetify.lang.current,
      {
        weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
      },
    )

    const isNew: ComputedRef<boolean> = computed(() => isNewSession(props.session))
    const locale: ComputedRef<string> = computed(() => context.root.$vuetify.lang.current)

    function cancel() {
      context.emit('cancel')
    }

    function formIsValid() {
      return true
    }

    async function save() {
      if (state.sessionData) {
        const noteHtml = (editorRef.value as unknown as & { getContentAsHtml: () => string }).getContentAsHtml().trim()
        // filter out empty p tags
        const noteToSave = noteHtml === '<p></p>' ? '' : noteHtml
        let cmd
        if (isExistingSession(state.sessionData)) {
          cmd = await ClientFlowApi.updateSession({
            note: noteToSave,
            clientId: state.sessionData.clientId,
            therapistId: state.sessionData.therapistId,
            date: state.sessionData.date,
            sessionId: state.sessionData.id,
          })
        } else {
          cmd = await ClientFlowApi.addSession({
            note: noteToSave,
            clientId: state.sessionData.clientId,
            therapistId: state.sessionData.therapistId,
            date: state.sessionData.date,
          })
        }
        const response = await handler.handle(cmd)
        if (response.isOk()) {
          context.emit('saved')
        }
      }
    }

    watch(
      () => state.datePickerDate,
      (newDate) => {
        // console.log(newDate)
        if (state.sessionData) {
          const theDate = new Date(newDate as unknown as string).toISOString()
          // console.log(theDate)
          state.sessionData.date = theDate
        }
      },
    )

    /**
     * The update function that is exposed to the template
     */
    async function onUpdateClientFields() {
      // await updateClientInfo(client.value.id, data)
    }

    onBeforeMount(() => {
      const now = new Date()
      state.sessionData = {
        ...props.session,
        note: props.session.note ? props.session.note : '',
        date: props.session.date ? props.session.date : now.toUTCString(),
      } // copy, not reference

      state.datePickerDate = new Date(state.sessionData.date).toISOString().substr(0, 10)

      //
    })

    // Make stuff available for the template
    return {
      // from self
      ...toRefs(state),
      editorRef,
      onUpdateClientFields,
      getFormattedDate,
      save,
      cancel,
      formIsValid,
      isNew,
      locale,
      // isNew,

      // from use ClienFlowApi
      hasResponseError,
      awaitingResponse,
      errorDisplay,

      // from useApiErrorViewHandler
      showingResponseError,
      showResponseError,
      toggleShowApiError,
      errorVisibilityHasChangedTo,
    }
  },
})

